/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aichatrestart2Inputs */

const en_aichatrestart2 = /** @type {(inputs: Aichatrestart2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start over`)
};

const de_aichatrestart2 = /** @type {(inputs: Aichatrestart2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neu starten`)
};

/**
* | output |
* | --- |
* | "Start over" |
*
* @param {Aichatrestart2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aichatrestart2 = /** @type {((inputs?: Aichatrestart2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aichatrestart2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aichatrestart2(inputs)
	return de_aichatrestart2(inputs)
});
export { aichatrestart2 as "aiChatRestart" }